import { createAction } from 'redux-actions';
import { actionDone, actionRequest } from '../action-helpers';
import { errorHandler } from '../ajax';
import { initEntity } from '@/common/lib/entity-module';
export const appInit = createAction('@@app/APP_INIT');
export const userInit = createAction('@@app/USER_INIT');
export const initRequest = actionRequest('@@app/INIT_REQUEST');
export const initSuccess = actionDone('@@app/INIT_SUCCESS', (res) => [
  initEntity({ target: 'web', data: res.web }),
]);
export const initFailure = actionDone('@@app/INIT_FAILURE', err => [errorHandler(err)]);
